export const events = [
  {
    id: 'basingstoke-2025',
    title: 'Crime Writing Festival at Basingstoke Discovery Centre',
    description: [
      'See me at the Crime Writing Festival at Basingstoke Discovery Centre.',
    ],
    date: 'Friday, October 24',
    imageKey: 'basingstokecrime',
    link: {
      label: 'Click here to find out more',
      url: 'https://www.hants.gov.uk/librariesandarchives/library/libraryfinder/basingstoke-discovery-centre',
    },
  },
  {
    id: 'plymouth-2026',
    title: 'Plymouth Literary Festival',
    description: [
      "FROM WOMAN'S OWN TO PRISON: HOW I BECAME A SUNDAY TIMES BEST-SELLING NOVELIST",
    ],
    date: 'Sunday, February 15, 2026, at 2:30 pm',
    imageKey: 'plymouthlit',
    link: {
      label: 'Click here to reserve your free ticket',
      url: 'https://www.eventbrite.com/e/jane-corry-how-i-became-a-sunday-times-best-selling-novelist-tickets-1828802119369?aff=oddtdtcreator',
    },
  },
];
